import React from 'react'
import i18n from 'live/services/i18n'
import * as S from './styled'

export interface ShowMoreFooterProps {
    fetchNextPage?: () => void
    loading?: boolean
    empty?: boolean
    emptyMessage?: string
    endOfPages?: boolean
    endOfPagesMessage?: string
}

const ShowMoreFooter: React.FC<ShowMoreFooterProps> = ({
    fetchNextPage,
    loading = false,
    empty,
    emptyMessage = '',
    endOfPages = true,
    endOfPagesMessage = ''
}) => {
    return (
        <span>
            <S.Container empty={empty}>
                {loading ? (
                    <button disabled={true} className="btn btn-block btn-primary">
                        <span>
                            <i className="fa fa-spinner fa-spin" /> {i18n('Loading...')}
                        </span>
                    </button>
                ) : !endOfPages && !empty ? (
                    <button onClick={fetchNextPage} className="btn btn-block btn-primary">
                        <span> {i18n('Show more')} </span>
                    </button>
                ) : empty ? (
                    <div>
                        <span> {emptyMessage} </span>
                    </div>
                ) : endOfPages ? (
                    <div>
                        <span> {endOfPagesMessage} </span>
                    </div>
                ) : null}
            </S.Container>
        </span>
    )
}

export default ShowMoreFooter
